import {inlineError, tracer} from '@s-ui/decorators/lib'
import {UseCase} from '@s-ui/domain'

/**
 * @implements UseCase
 */
export class UpdatePasswordUserUseCase extends UseCase {
  /**
   * @constructor
   * @param {Object} deps
   * @param {Repository} deps.cookieUserRepository
   * @param {Service} deps.getCurrentUserService
   * @param {RequestFactory} deps.updatePasswordUserRequestFactory
   * @param {ErrorFactory} deps.userNotLoggedInUserErrorFactory
   * @param {Repository} deps.userRepository
   */
  constructor({
    cookieUserRepository,
    getCurrentUserService,
    updatePasswordUserRequestFactory,
    userNotLoggedInUserErrorFactory,
    userRepository
  }) {
    super()
    this._cookieUserRepository = cookieUserRepository
    this._getCurrentUserService = getCurrentUserService
    this._updatePasswordUserRequestFactory = updatePasswordUserRequestFactory
    this._userNotLoggedInUserErrorFactory = userNotLoggedInUserErrorFactory
    this._userRepository = userRepository
  }

  @tracer({metric: 'UpdatePasswordUserUseCase#execute'})
  @inlineError
  async execute(params) {
    const userEntity = await this._getCurrentUserService.execute()

    if (!userEntity)
      return Promise.reject(
        this._userNotLoggedInUserErrorFactory({
          message: 'To update personal data the user must be logged in'
        }).toJSON()
      )

    const token = userEntity.getToken()

    const updatePasswordUserRequest = this._updatePasswordUserRequestFactory({
      ...params,
      token
    })

    const [error, updatePasswordResponse] = await this._userRepository.updateUserPassword({
      updatePasswordUserRequest,
      userEntity
    })

    if (error) return Promise.reject(error)

    const {token: newToken, authenticationToken} = updatePasswordResponse.toJSON()

    if (this._cookieUserRepository) {
      if (authenticationToken) {
        // TODO debt: instead of passing raw data, use VO
        await this._cookieUserRepository.setAuthenticationToken({
          authenticationToken,
          userId: userEntity.getId()
        })
      }
      if (newToken) {
        // TODO debt: instead of passing raw data, use VO
        await this._cookieUserRepository.setToken({token: newToken})
      }
    }

    return Promise.resolve()
  }
}
